/**
 * Shared preset tag lists and colors used across org create, regulations create,
 * events, profile preferences, and filter UIs.
 *
 * Single source of truth — import from here instead of duplicating arrays.
 */

// ── Tag arrays ────────────────────────────────────────────────────────────────

// Ordered disciplines appear first (dropdown-eligible), followed by unordered ones.
export const DISCIPLINE_TAGS = ["Safety", "RF", "EMC", "Restricted Substances", "Ecodesign", "Energy Efficiency", "Repair", "Extended Producer Responsibility", "Social Responsibility", "Battery", "Packaging", "Standards", "Test Equipment", "Quality Management Systems", "Medical", "Trade Compliance", "Cyber Security", "Children's Products", "Reliability & Performance", "Transportation", "Interoperability", "Carrier Requirements", "Calibration"];
export const PRODUCT_TAGS = ["Consumer Electronics", "IT Equipment", "Smart Home", "Robotics", "Drones", "Wearables", "Medical Devices", "Appliances", "Life Safety Devices", "Materials & Components", "Automotive", "Cyber Security & Privacy", "Test & Measurement Equipment", "Data Center", "Industrial Equipment", "Agricultural Equipment", "Aerospace", "Energy Generation & Storage"];
export const REGION_TAGS = ["Global", "North America", "Europe", "Latin America", "Oceana", "Asia", "Middle East", "Africa"];

// Mutable copies when a `string[]` is needed by components accepting mutable arrays
export const DISCIPLINE_TAGS_MUTABLE = [...DISCIPLINE_TAGS];
export const PRODUCT_TAGS_MUTABLE = [...PRODUCT_TAGS];
export const REGION_TAGS_MUTABLE = [...REGION_TAGS];

// ── Colors ────────────────────────────────────────────────────────────────────

export const TAG_COLORS = {
  discipline: {
    primary: "#4caf50",
    dark: "#388e3c"
  },
  product: {
    primary: "#2196f3",
    dark: "#1976d2"
  },
  region: {
    primary: "#9c27b0",
    dark: "#7b1fa2"
  }
};